import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Auracabserviceinpune() {



  const cardData = {




keyword: "Aura Cab Service in Pune",

headingDescription: "Garud Cab Service provides comfortable and reliable Aura Cab Service in Pune for airport transfers, corporate travel, family journeys, local transportation, railway station transfers, sightseeing, and long-distance trips. The Hyundai Aura offers comfortable seating, a practical cabin, useful luggage space, and efficient performance, making it suitable for individuals, couples, and small families. Customers can book a chauffeur-driven Aura for one-way journeys, round trips, airport pickup and drop, business travel, and customized travel plans. With clean and well-maintained vehicles, experienced drivers, flexible pickup locations, transparent pricing, and 24/7 customer assistance, Garud Cab Service provides a convenient and dependable cab experience from Pune to popular destinations.",

topPlaces: [
  {
    title: "Kaas Plateau",
    description: "Kaas Plateau is a scenic natural destination near Satara known for its seasonal wildflowers, grasslands, small lakes, and surrounding Sahyadri landscapes. It is especially attractive during the flowering season and is popular among nature lovers and photographers. An Aura cab provides a comfortable option for couples and small families traveling from Pune, with convenient space for personal luggage. Garud Cab Service can arrange chauffeur-driven travel for a direct visit, return journey, or customized sightseeing plan."
  },
  {
    title: "Thoseghar Waterfalls",
    description: "Thoseghar Waterfalls is a beautiful monsoon attraction near Satara featuring a series of waterfalls surrounded by green hills and valleys. The destination is ideal for travelers looking for a refreshing nature trip away from the city. A Hyundai Aura is suitable for smaller groups who prefer private and economical transportation from Pune. Customers can book the cab for a round trip with flexible pickup and sightseeing arrangements."
  },
  {
    title: "Malshej Ghat",
    description: "Malshej Ghat is a scenic mountain destination known for dramatic valleys, waterfalls, misty hills, and winding roads through the Western Ghats. It is a popular weekend destination for couples, families, and nature enthusiasts traveling from Pune. The Aura provides a comfortable sedan experience for smaller groups and moderate luggage. Garud Cab Service offers chauffeur-driven journeys with flexible stopping options for enjoying the surrounding scenery."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a peaceful hill and lakeside destination surrounded by mountains, forests, waterfalls, and beautiful natural landscapes. Popular attractions around the region include Arthur Lake and Randha Falls. An Aura cab is a practical choice for couples and small families planning a private trip from Pune. Customers can arrange one-way or round-trip transportation and customize their sightseeing schedule according to their travel plans."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a picturesque hill destination in the Western Ghats known for green mountains, waterfalls, trekking areas, and a peaceful atmosphere. It is suitable for weekend trips, family outings, and nature-focused travel from Pune. The Hyundai Aura offers comfortable seating for smaller groups and convenient luggage space. Garud Cab Service provides professional chauffeur-driven cab bookings with flexible travel timings and pickup arrangements."
  },
  {
    title: "Dapoli",
    description: "Dapoli is a popular Konkan destination known for beaches, coastal villages, temples, greenery, and a relaxed holiday atmosphere. The longer journey from Pune is convenient in a private sedan when traveling as a couple or small family. Aura Cab Service provides a comfortable and economical option for passengers carrying moderate luggage. Customers can book direct travel, return trips, or customized coastal sightseeing."
  },
  {
    title: "Kashid",
    description: "Kashid is a beautiful coastal destination in Maharashtra known for its sandy beach, blue sea, greenery, and peaceful surroundings. It is a popular weekend choice for couples and families seeking a relaxing beach holiday. Travelers from Pune can choose a Hyundai Aura for a private road journey with convenient luggage space. Garud Cab Service can arrange flexible pickup, return travel, and nearby coastal sightseeing."
  },
  {
    title: "Murud",
    description: "Murud is a scenic Konkan destination known for its coastline, beaches, traditional coastal surroundings, and access to the historic Murud-Janjira region. It is suitable for travelers planning a combination of beach and heritage sightseeing. An Aura sedan provides a comfortable option for smaller groups traveling from Pune. Customers can hire the cab for a direct journey or a customized return itinerary covering nearby attractions."
  },
  {
    title: "Panhala",
    description: "Panhala is a historic hill destination near Kolhapur known for its impressive fort, scenic viewpoints, cool surroundings, and connection with Maratha history. It is a suitable destination for families and history enthusiasts planning a short getaway from Pune. The Aura provides comfortable private transportation for smaller groups. Garud Cab Service can arrange chauffeur-driven travel with flexible stops and return scheduling."
  },
  {
    title: "Narsobawadi",
    description: "Narsobawadi is an important religious destination in Maharashtra associated with Lord Dattatreya and Shri Narasimha Saraswati. Located near the Krishna River, the town provides a peaceful atmosphere for devotees and spiritual travelers. An Aura cab is suitable for couples and small families visiting from Pune for Darshan. Customers can also customize their journey to include nearby temples and religious attractions."
  }
],




"services": [
{
"name": "Aura Cab Service in Pune",
"description": "Book Aura Cab Service in Pune for comfortable and reliable city, airport, and outstation travel with professional chauffeurs and well-maintained air-conditioned Hyundai Aura cars. The service is suitable for families, individuals, tourists, corporate travelers, local transfers, airport pickups, and scheduled one-way or round-trip journeys."
},
{
"name": "Hyundai Aura Rental Pune",
"description": "Choose Hyundai Aura Rental Pune for convenient chauffeur-driven transportation with comfortable seating, AC interiors, luggage space, and flexible travel arrangements. Hyundai Aura is suitable for local travel, airport transfers, business visits, family trips, sightseeing, and outstation journeys from Pune."
},
{
"name": "Hyundai Aura Taxi Booking Pune",
"description": "Make Hyundai Aura Taxi Booking Pune for a comfortable private journey with a professional driver and clean air-conditioned vehicle. The service is suitable for office travel, airport transfers, personal visits, family transportation, sightseeing, and outstation trips with convenient pickup and destination drop."
},
{
"name": "Sedan Cab Service Pune",
"description": "Book Sedan Cab Service Pune with Hyundai Aura and other comfortable sedan options for reliable city and outstation transportation. Enjoy professional chauffeur service, AC interiors, convenient pickup, comfortable seating, and flexible travel options for individuals, families, tourists, and corporate passengers."
},
{
"name": "Hyundai Aura Car Booking Pune",
"description": "Reserve Hyundai Aura Car Booking Pune for private chauffeur-driven transportation with convenient pickup and direct destination drop. The comfortable sedan is suitable for local travel, airport transfers, business meetings, family journeys, sightseeing, and outstation trips requiring an economical and practical vehicle."
},
{
"name": "Aura Outstation Cab Pune",
"description": "Choose Aura Outstation Cab Pune for comfortable long-distance travel with a professional chauffeur and well-maintained AC Hyundai Aura. The service is suitable for one-way transfers, round trips, family journeys, business travel, sightseeing, and personal visits to destinations from Pune."
},
{
"name": "Hyundai Aura Airport Transfer Pune",
"description": "Book Hyundai Aura Airport Transfer Pune for convenient airport pickup and drop services with scheduled transportation and professional chauffeurs. Enjoy a comfortable AC sedan with practical luggage space for passengers traveling to or from Pune Airport for business, family, tourism, and personal requirements."
},
{
"name": "Pune Aura Car Hire",
"description": "Hire a Pune Aura Car with a professional chauffeur for comfortable and convenient transportation across Pune and nearby destinations. Hyundai Aura provides AC interiors, comfortable seating, and practical luggage capacity for airport transfers, office travel, sightseeing, family trips, and outstation journeys."
},
{
"name": "Hyundai Aura Tourist Vehicle Pune",
"description": "Choose Hyundai Aura Tourist Vehicle Pune for comfortable sightseeing and private tourist transportation with an experienced chauffeur. The sedan is suitable for couples, families, small groups, and visitors exploring Pune or traveling to nearby attractions with flexible pickup and travel arrangements."
},
{
"name": "Hyundai Aura Online Cab Booking Pune",
"description": "Make Hyundai Aura Online Cab Booking Pune for convenient private transportation with scheduled pickup and direct destination drop. Select the Hyundai Aura for local rides, airport transfers, corporate travel, sightseeing, family trips, and outstation journeys while enjoying comfortable AC travel with a professional chauffeur."
},
{
"name": "Hyundai Aura Cab in Hinjewadi Pune",
"description": "Book Hyundai Aura Cab in Hinjewadi Pune for comfortable transportation to IT parks, offices, residential areas, Pune Airport, and outstation destinations. Professional chauffeur service and AC interiors make the vehicle suitable for employees, corporate travelers, families, airport passengers, and personal travel."
},
{
"name": "Hyundai Aura Cab in Kharadi Pune",
"description": "Choose Hyundai Aura Cab in Kharadi Pune for reliable local, airport, corporate, and outstation transportation. Enjoy convenient pickup from homes, offices, hotels, and business locations with a professional chauffeur, comfortable AC seating, and practical luggage space for individuals and small families."
},
{
"name": "Hyundai Aura Cab in Hadapsar Pune",
"description": "Book Hyundai Aura Cab in Hadapsar Pune for comfortable city and outstation travel with convenient pickup arrangements and professional chauffeur service. The sedan is suitable for office travel, airport transfers, family journeys, sightseeing, hotel transfers, and private trips from Hadapsar to destinations across Maharashtra."
},
{
"name": "Hyundai Aura Cab in Baner Pune",
"description": "Reserve Hyundai Aura Cab in Baner Pune for comfortable transportation to offices, hotels, Pune Airport, residential areas, and outstation destinations. The AC sedan provides convenient seating and luggage space for corporate travelers, families, tourists, and individuals requiring reliable chauffeur-driven travel."
},
{
"name": "Hyundai Aura Cab in Wakad Pune",
"description": "Hire Hyundai Aura Cab in Wakad Pune for convenient local, airport, corporate, and outstation transportation. Enjoy professional chauffeur service, clean AC interiors, comfortable seating, and scheduled pickup from homes, offices, hotels, and other locations in Wakad for private travel."
},
{
"name": "Hyundai Aura Cab in Pimpri Chinchwad",
"description": "Book Hyundai Aura Cab in Pimpri Chinchwad for reliable transportation across PCMC, Pune Airport, business locations, and outstation destinations. The Hyundai Aura is suitable for individuals, families, corporate passengers, tourists, and small groups looking for comfortable chauffeur-driven sedan travel."
},
{
"name": "Hyundai Aura Cab in Viman Nagar Pune",
"description": "Choose Hyundai Aura Cab in Viman Nagar Pune for convenient airport transfers, local travel, business transportation, and outstation journeys. With comfortable AC interiors, practical luggage space, and professional chauffeurs, the sedan is suitable for travelers staying near hotels, offices, and Pune Airport."
},
{
"name": "Hyundai Aura Cab in Kothrud Pune",
"description": "Reserve Hyundai Aura Cab in Kothrud Pune for comfortable city rides, airport transfers, family travel, sightseeing, and outstation transportation. Enjoy convenient door-to-door pickup, experienced chauffeur service, AC seating, and a practical sedan option for individuals and small groups."
},
{
"name": "Hyundai Aura Cab in Magarpatta Pune",
"description": "Book Hyundai Aura Cab in Magarpatta Pune for corporate travel, airport transfers, local transportation, hotel pickups, and outstation journeys. The comfortable AC sedan is suitable for professionals, families, tourists, and individuals requiring scheduled chauffeur-driven transportation from Magarpatta."
},
{
"name": "Hyundai Aura Cab in Wagholi Pune",
"description": "Choose Hyundai Aura Cab in Wagholi Pune for reliable local and long-distance transportation with convenient pickup and destination drop. The sedan provides comfortable AC travel for office commuters, families, airport passengers, tourists, and customers planning outstation journeys from Wagholi."
},
{
"name": "Hyundai Aura Cab in Pune",
"description": "Book Hyundai Aura Cab in Pune for comfortable private transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for local rides, airport transfers, corporate travel, sightseeing, family trips, hotel transfers, one-way journeys, and outstation travel."
},
{
"name": "Hyundai Aura Cab Service Pune",
"description": "Choose Hyundai Aura Cab Service Pune for dependable chauffeur-driven sedan transportation with comfortable AC interiors and convenient pickup arrangements. The service is suitable for business travel, airport transfers, family trips, tourist journeys, local transportation, and outstation travel from Pune."
},
{
"name": "Hyundai Aura Taxi Service Pune",
"description": "Book Hyundai Aura Taxi Service Pune for private and comfortable travel with experienced drivers and clean air-conditioned vehicles. Customers can use the sedan for city rides, airport transfers, corporate transportation, sightseeing, family journeys, hotel transfers, and outstation trips."
},
{
"name": "Hyundai Aura Cab Booking Pune",
"description": "Make Hyundai Aura Cab Booking Pune for scheduled chauffeur-driven transportation with convenient pickup and direct drop facilities. Select the Hyundai Aura for comfortable local travel, airport transfers, business meetings, family trips, sightseeing, and outstation journeys according to your preferred timing."
},
{
"name": "Hyundai Aura Car Rental Pune",
"description": "Hire Hyundai Aura Car Rental Pune with a professional chauffeur for comfortable and convenient transportation throughout Pune and nearby destinations. The sedan offers AC interiors, comfortable seating, practical luggage space, and flexible travel options for local, airport, corporate, tourist, and outstation journeys."
},
{
"name": "Hyundai Aura with Driver Pune",
"description": "Book Hyundai Aura with Driver Pune for stress-free chauffeur-driven transportation with a comfortable AC sedan. The service is suitable for personal travel, business meetings, airport transfers, sightseeing, family trips, hotel transportation, and outstation journeys where passengers prefer convenient private travel."
},
{
"name": "Hyundai Aura Outstation Cab Pune",
"description": "Choose Hyundai Aura Outstation Cab Pune for comfortable intercity travel with a professional chauffeur and well-maintained AC vehicle. The sedan is suitable for one-way trips, round trips, family travel, business journeys, sightseeing, and personal visits to destinations from Pune."
},
{
"name": "Hyundai Aura Airport Cab Pune",
"description": "Reserve Hyundai Aura Airport Cab Pune for convenient pickup and drop transportation to and from Pune Airport. Enjoy comfortable AC seating, practical luggage space, professional chauffeur service, and scheduled travel suitable for business passengers, families, tourists, and individuals."
},
{
"name": "Online Hyundai Aura Booking Pune",
"description": "Book Online Hyundai Aura Booking Pune for convenient chauffeur-driven transportation with scheduled pickup and direct destination drop. The Hyundai Aura is suitable for airport transfers, local travel, corporate transportation, sightseeing, family journeys, and outstation trips requiring a comfortable sedan."
},
{
"name": "Hyundai Aura Sedan Cab Pune",
"description": "Choose Hyundai Aura Sedan Cab Pune for practical and comfortable private transportation with air-conditioned interiors and professional chauffeur service. The sedan is suitable for individuals, couples, small families, corporate travelers, airport passengers, tourists, local rides, and outstation journeys."
},
{
"name": "Hyundai Aura Round Trip Cab Pune",
"description": "Book Hyundai Aura Round Trip Cab Pune for convenient return transportation according to your travel schedule. Enjoy private AC travel, professional chauffeur service, comfortable seating, and flexible pickup arrangements for sightseeing, family visits, business travel, weekend trips, and outstation journeys."
},
{
"name": "Best Hyundai Aura Cab Service Pune",
"description": "Choose Best Hyundai Aura Cab Service Pune for comfortable chauffeur-driven transportation with clean AC vehicles, experienced drivers, convenient pickup, and flexible journey options. The service is suitable for airport transfers, corporate travel, family trips, sightseeing, local rides, and outstation transportation."
}
],
"tableData": [
["Aura Cab Service in Pune", "Hyundai Aura Rental Pune"],
["Hyundai Aura Taxi Booking Pune", "Sedan Cab Service Pune"],
["Hyundai Aura Car Booking Pune", "Aura Outstation Cab Pune"],
["Hyundai Aura Airport Transfer Pune", "Pune Aura Car Hire"],
["Hyundai Aura Tourist Vehicle Pune", "Hyundai Aura Online Cab Booking Pune"],
["Hyundai Aura Cab in Hinjewadi Pune", "Hyundai Aura Cab in Kharadi Pune"],
["Hyundai Aura Cab in Hadapsar Pune", "Hyundai Aura Cab in Baner Pune"],
["Hyundai Aura Cab in Wakad Pune", "Hyundai Aura Cab in Pimpri Chinchwad"],
["Hyundai Aura Cab in Viman Nagar Pune", "Hyundai Aura Cab in Kothrud Pune"],
["Hyundai Aura Cab in Magarpatta Pune", "Hyundai Aura Cab in Wagholi Pune"],
["Hyundai Aura Cab in Pune", "Hyundai Aura Cab Service Pune"],
["Hyundai Aura Taxi Service Pune", "Hyundai Aura Cab Booking Pune"],
["Hyundai Aura Car Rental Pune", "Hyundai Aura with Driver Pune"],
["Hyundai Aura Outstation Cab Pune", "Hyundai Aura Airport Cab Pune"],
["Online Hyundai Aura Booking Pune", "Hyundai Aura Sedan Cab Pune"],
["Hyundai Aura Round Trip Cab Pune", "Best Hyundai Aura Cab Service Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Aura Cab Service in Pune for Convenient Travel",
    WhyChoosedescription: "Garud Cab Service offers Hyundai Aura cab services in Pune for city travel, airport transfers, office visits, family transportation, railway station pickups, and selected outstation journeys."
  },
  {
    WhyChooseheading: "Smart Sedan Option for Daily Travel",
    WhyChoosedescription: "Hyundai Aura is a practical sedan for passengers who want a comfortable private ride with a compact design that works well for regular Pune city transportation."
  },
  {
    WhyChooseheading: "Airport Pickup & Drop Made Simple",
    WhyChoosedescription: "Book an Aura cab for Pune Airport transfers when you need convenient transportation between the airport and your home, hotel, office, or another preferred pickup or drop location."
  },
  {
    WhyChooseheading: "Useful for Corporate & Office Visits",
    WhyChoosedescription: "Aura cab service can be arranged for business meetings, client appointments, office travel, interviews, corporate visits, and other professional transportation requirements."
  },
  {
    WhyChooseheading: "Comfortable Choice for Small Groups",
    WhyChoosedescription: "The sedan is suitable for individuals, couples, and small families who need a private vehicle for city travel, shopping, family visits, appointments, and short journeys."
  },
  {
    WhyChooseheading: "Local Pune Travel & Sightseeing",
    WhyChoosedescription: "Hire an Aura cab for local sightseeing, hotel transfers, railway station travel, shopping trips, social functions, medical appointments, and other transportation needs around Pune."
  },
  {
    WhyChooseheading: "Outstation Travel from Pune",
    WhyChoosedescription: "Aura cab arrangements can also be considered for suitable outstation routes from Pune, including family visits, short holidays, religious journeys, and intercity transportation."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your pickup location, destination, travel date, passenger count, and one-way or return requirement with Garud Cab Service to arrange a suitable Aura cab in Pune."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Aura Cab Service in Pune?",
    answer: "Yes, Garud Cab Service provides Hyundai Aura cab services in Pune for local travel, airport transfers, corporate transportation, family trips, railway station transfers, and suitable outstation journeys."
  },
  {
    question: "Can I book an Aura cab for Pune Airport?",
    answer: "Yes, Hyundai Aura cabs can be arranged for Pune Airport pickup and drop services according to your flight schedule and preferred travel timing."
  },
  {
    question: "Is Aura cab suitable for small families?",
    answer: "Yes, Hyundai Aura is a practical sedan option for individuals, couples, and small families travelling with moderate luggage."
  },
  {
    question: "Can I use Aura Cab Service for corporate travel?",
    answer: "Yes, Aura cabs can be used for business meetings, office visits, client appointments, interviews, corporate transfers, and other professional travel requirements."
  },
  {
    question: "Can I book Aura for outstation travel?",
    answer: "Yes, Aura cab arrangements can be made for suitable outstation destinations from Pune based on the route, travel date, and vehicle availability."
  },
  {
    question: "Can I book a one-way Aura cab?",
    answer: "Yes, one-way cab service is available for passengers who need direct transportation from Pune to their selected destination."
  },
  {
    question: "Is round-trip Aura cab service available?",
    answer: "Yes, round-trip arrangements can be planned for sightseeing, family visits, business appointments, airport requirements, and outstation journeys."
  },
  {
    question: "Can I hire an Aura cab for local Pune sightseeing?",
    answer: "Yes, Aura cabs can be arranged for local sightseeing, shopping, hotel transfers, railway station travel, appointments, and other city transportation requirements."
  },
  {
    question: "Is Aura Cab Service available with a driver?",
    answer: "Yes, chauffeur-driven Aura cab service can be arranged for customers who prefer convenient private transportation with a professional driver."
  },
  {
    question: "How can I book an Aura Cab in Pune?",
    answer: "Share your pickup location, destination, travel date, passenger details, and trip type with Garud Cab Service to arrange your Hyundai Aura cab."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Shinde",
    feedback: "I booked an Aura cab for a Pune Airport transfer and the arrangement was convenient. The car worked well for my travel and luggage requirements.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Pawar",
    feedback: "Our family used an Aura cab for local travel in Pune. The private ride was comfortable for our small group and the booking process was straightforward.",
    rating: 5
  }
];



  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Aura Cab Service in Pune",
  "image": "https://garudcabs.com/assets/images/aura-cab-service-in-pune.webp",
  "description": "Book Aura Cab Service in Pune with Garud Cab for comfortable, economical, and reliable local, airport, and outstation travel. Get Hyundai Aura rental and taxi booking services for one way trips, round trips, airport transfers, corporate travel, family journeys, and convenient city transportation with professional cab service.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/aura-cab-service-in-pune"
  }
};








  return (
    <div>


<Helmet>
  <title>Aura Cab Service in Pune | Hyundai Aura Rental & Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Aura Cab Service in Pune with Garud Cab for comfortable and affordable travel. Get Hyundai Aura rental, taxi booking, sedan cab, airport, local, and outstation services with convenient one way and round trip options."
  />

  <meta
    name="keywords"
    content="Aura Cab Service in Pune, Hyundai Aura Rental Pune, Hyundai Aura Taxi Booking Pune, Sedan Cab Service Pune, Hyundai Aura Car Booking Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Auracabserviceinpune;